import { HttpService } from './http.service';

export default {
    async updateEmail(incentiveRegistrationId, data) {
        return await HttpService.httpPost(`/incentive-registration/update-email/${incentiveRegistrationId}`, data);
    },
}
